export default __webpack_public_path__ + "static/media/icon-twitter.d12b6e86.svg";